export default __webpack_public_path__ + "static/media/home-app-logo.547c2c58.svg";